import React from 'react';
import { number, string } from 'prop-types';

const IconLabel = ({ size = 30, fill = '#30435D' }) => {
  return (
    <svg data-test="iconlabel" width={size} height={size} viewBox="0 0 30 30" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6275 5.27804C14.3299 4.6887 15.1886 4.4348 15.9211 4.54138L24.7916 5.80958L24.5002 14.7655C24.478 15.5054 24.0788 16.307 23.3765 16.8964L11.8385 26.5637C10.6854 27.5313 9.12223 27.5843 8.35624 26.6715L1.39271 18.3727C0.626718 17.4598 0.950408 15.9295 2.10351 14.962L13.6275 5.27804ZM10.4526 24.9123L21.9836 15.2366L22.2232 7.96461L15.0201 6.9378L3.4891 16.6134L10.4526 24.9123Z"
        fill={fill}
      />
      <circle cx="18.5096" cy="11.1782" r="2" transform="rotate(-40 18.5096 11.1782)" fill={fill} />
    </svg>
  );
};

IconLabel.propTypes = {
  size: number,
  fill: string,
};

export default IconLabel;
